var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Humidity Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "32x32-copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 5.5,
    x2: 1.5,
    y2: 5.5,
    id: "Line",
    stroke: "#979797",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,6.19416756 C3.60887811,7.77652808 5.70462464,8.56770833 7.78723958,8.56770833 C9.86985453,8.56770833 12.1177921,7.77652808 14.5310524,6.19416756 C16.8895205,4.42713572 19.0396881,3.54361979 20.9815553,3.54361979 C22.9234225,3.54361979 25.0962374,4.42713572 27.5,6.19416756",
    id: "Line-2",
    stroke: "#1991DC",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,14.1941676 C3.94894037,15.7651565 6.21471803,16.550651 8.29733297,16.550651 C10.3799479,16.550651 12.4578544,15.7651565 14.5310524,14.1941676 C16.8895205,12.4271357 19.0396881,11.5436198 20.9815553,11.5436198 C22.9234225,11.5436198 25.0962374,12.4271357 27.5,14.1941676",
    id: "Line-2",
    stroke: "#1991DC",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,22.1941676 C3.94894037,23.7651565 6.21471803,24.550651 8.29733297,24.550651 C10.3799479,24.550651 12.4578544,23.7651565 14.5310524,22.1941676 C16.8895205,20.4271357 19.0396881,19.5436198 20.9815553,19.5436198 C22.9234225,19.5436198 25.0962374,20.4271357 27.5,22.1941676",
    id: "Line-2",
    stroke: "#1991DC",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7218476,19.5147171 L27.500006,16 L24.2781846,19.5147171 C22.4988209,21.4558192 22.4988209,24.6030105 24.2781846,26.5441237 C26.0575484,28.4852921 28.9424433,28.4852921 30.7218476,26.5441237 C32.5012012,24.6030105 32.5012012,21.4558192 30.7218476,19.5147171 Z",
    id: "Path",
    fill: "#1991DC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/Humidity.14e5d2692a5ef99749ceae7e3fe58772.svg";
export { ForwardRef as ReactComponent };